import classNames from 'classnames/bind';

import styles from './NoDataComponent.module.scss';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import { useTranslation } from 'react-i18next';
import useIsMobile from '@/componentShare/hooks/useIsMobile';

const cx = classNames.bind(styles);

type Props = {
    title: string
}

export default function NoDataComponent({ title }: Props) {
    const { t } = useTranslation()
    const matches = useIsMobile();

    return (
        <>
            <div className={matches ? cx("no-data-copy-trade", "mobile") : cx("no-data-copy-trade")}>

                <div className={cx("title")}>{title ?? "Title"}</div>

                <div className={cx("no-data")}>
                    <TypographyElement ColorElement="secondary">
                        {t("copytrade.common.noData")}
                    </TypographyElement>
                </div>
            </div>

        </>
    )
}